exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-web-containers-main-___loading__loading___vOYih {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  margin-top: -20px;\n  margin-left: -20px;\n}", ""]);

// Exports
exports.locals = {
	"loading": "src-web-containers-main-___loading__loading___vOYih"
};